<template>
  <div class="chrome">
    <span class="progress">{{ index + 1 }} / {{ total }}</span>
    <h2 class="title">{{ title }}</h2>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  index: { type: Number, required: true },
  total: { type: Number, required: true },
})
</script>

<style scoped>
.chrome {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border);
}

.progress {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--teal);
  margin-bottom: 0.25rem;
}

.title {
  margin: 0;
  font-size: 1.5rem;
}
</style>
